import { Injectable } from '@angular/core';
import * as fileSaver from 'file-saver';
import { map, catchError } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class FlowService {

  constructor(private _http: HttpClient) { }

  // get flow's list
  getAllFlows(agentId) {
    return this._http.get(environment.flow_api + agentId + '/')
  }

  // create flow
  createFlow(agentId, params) {
    return this._http.post(environment.flow_api + agentId + '/', params)
  }

  /*Import Flow from Library*/
  importFlowFromLibrary(agentId) {
    return this._http.get(environment.flow_api + agentId + '/flow_library')
      .pipe(
        map((response: Array<Object>) => response),
        catchError((err: Response) => {
          console.log(err);
          return of([]); // Returning an empty array in case of error
        })
      );
  }

  /*Save Flow list from library*/
  saveFlowList(agentId, params) {
    return this._http.post(environment.flow_api + agentId + '/import_flow_library', params)
  }

  // import flow
  importFlow(agentId, file) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this._http.post(environment.flow_api + agentId + '/import_flow', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }
  //resume flow
  resumeFlow(agentId, flowId, params) {

    return this._http.put(environment.flow_api + agentId + '/flow/' + flowId.$oid, params)
  }

  // export flow
  exportFlow(agentId, flowID, flow_name) {
    return this._http.get(environment.flow_api + agentId + '/flow/' + flowID + '/export_flow').pipe(
      map((response: any) => {
        let blob = new Blob([JSON.stringify(response)], { type: 'application/json' });
        fileSaver.saveAs(blob, `${flow_name}_${agentId}.json`);
      }),
      catchError((err: any) => {
        console.log(err);
        return of(null); // Return observable to handle error
      })
    );
  }

  // delete flow
  deleteFlow(agentId, flowID) {
    return this._http.delete(environment.flow_api + agentId + '/flow/' + flowID)
  }

  // update flow data
  updateFlowData(agentId, flowID, params) {
    return this._http.put(environment.flow_api + agentId + '/flow/' + flowID, params)
  }

  // get flow data
  getFlowData(agentId, flowID) {
    return this._http.get(environment.flow_api + agentId + '/flow/' + flowID)
  }

  /*API for set label*/
  setFlowLabel(agentId,flowID,params){
    return this._http.post(environment.flow_api + agentId + '/flow/' + flowID + '/set_flow_labels', params)
  }

  // /*Set selected tag labels*/
  // selectTagLabel(){
  //   return this._http.post(environment.flow_api + agentId + '/flow/' + flowID + '/set_flow_labels', params)
  //   .map((response) => {
  //     return response;
  //   },
  //     (err: Response) => {
  //       console.log(err);
  //     });
  // }
  /*To get taglist*/
  getTaglist(agentId){
    return this._http.get(environment.flow_api + agentId + '/get_unique_labels')
  }
  // get flow trigger
  getFlowTrigger(agentId, flowID, nodeID) {
    return this._http.get(environment.flow_api + agentId + '/flow/' + flowID + '/nodes/' + nodeID + '/get_trigger_details')
  }

  // update flow trigger
  updateFlowTrigger(agentId, flowID, params) {
    return this._http.post(environment.flow_api + agentId + '/flow/' + flowID + '/save_trigger_details', params)
  }

  // get all nodes
  getAllNodes(agentId, flowID) {
    return this._http.get(environment.flow_api + agentId + '/flow/' + flowID + '/get_all_nodes')
  }

  // get all nodes
  getFlowNodes(agentId, flowID) {
    return this._http.get(environment.flow_api + agentId + '/flow/' + flowID + '/get_all_flow_data')
  }

  // get complete flow nodes
  getCompleteFlowNodes(agentId, flowID) {
    return this._http.get(environment.flow_api + agentId + '/flow/' + flowID + '/get_complete_flow_data')
  }

  // get flow node
  getFlowNode(agentId, flowID, nodeID) {
    return this._http.get(environment.flow_api + agentId + '/flow/' + flowID + '/nodes/' + nodeID + '/get_node_details')
  }

  // Temp function for compatibility for multi content
  convertMulticontentToText(response_json){

    response_json.bot_message.forEach((element,index,array) => {
      if(typeof (element.message) == "object"){
        array[index].message=  element.message[0].data;
        debugger;
      }
      
    });

      return response_json
  }

  // update flow node
  updateFlowNode(agentId, flowID, params) {
    return this._http.post(environment.flow_api + agentId + '/flow/' + flowID + '/save_node_details', params)
  }

  // update flow connector
  updateFlowConnector(agentId, flowID, params) {
    return this._http.post(environment.flow_api + agentId + '/flow/' + flowID + '/save_connector_details', params)
  }

  // delete flow node
  deleteFlowNode(agentId, flowID, nodeID) {
    return this._http.delete(environment.flow_api + agentId + '/flow/' + flowID + '/nodes/' + nodeID)
  }

  // delete flow node
  deleteFlowTrigger(agentId, flowID, nodeID) {
    return this._http.delete(environment.flow_api + agentId + '/flow/' + flowID + '/trigger/' + nodeID)
  }

  // delete flow connector
  deleteFlowConnector(agentId, flowID, nodeID) {
    return this._http.delete(environment.flow_api + agentId + '/flow/' + flowID + '/connector/' + nodeID)
  }

  // get all Forms
  getFormsList(agentId) {
    const params = { 'ui_library_type': 'form' };
    return this._http.post(environment.va_service_api + 'ui-library/filter-ui-library/' + agentId, params)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          console.error('Error occurred:', err);
          return throwError(err);
        })
      );
  }

  getAnnotatedDocumentList(agentId) {
    return this._http.get(environment.va_service_api + 'form-assistant/' + agentId + '/annotated_doc_list')
  }

    // get filter flow's list
    getFilterFlows(agentId, params) {
      return this._http.post(environment.flow_api + agentId + '/filter-flows', params)
    }

  getAllTopics(agentId){
    return this._http.get(`${environment.flow_api}${agentId}/topics`)
  }

  getAllFeatures(agentId) {
    return this._http.get(`${environment.flow_api}${agentId}/features`)
  }

  getAllSubFeatures(agentId) {
    return this._http.get(`${environment.flow_api}${agentId}/subfeatures`)
  }

  getAllProfiles(agentId) {
    return this._http.get(`${environment.flow_api}${agentId}/profiles`)
  }

  getAllEvents(agentId) {
    return this._http.get(`${environment.flow_api}${agentId}/events`)
  }
  



}
